<template>
<div>
  <div class="event-picture">
    <img :src="notice_image||defaultCover" alt="">
  </div>
  <div class="event-title">{{title}}</div>
</div>
</template>

<script>
import vueTypes from 'vue-types'
export default {
  name: 'event-detail-info',
  data () {
    return {
      defaultCover: 'https://static001-test.geekbang.org/resource/image/fa/09/fa90a3cf00ca34dfed620edba4430609.png'
    }
  },
  props: {
    title: vueTypes.string.isRequired,
    notice_image: vueTypes.string.isRequired
  }
}
</script>

<style lang="scss" scoped>
  .event-title {
    font-weight: 500;font-size: 25px;color: #3E404A;
    margin-bottom: 25px;
  }
  .event-picture {
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 56%;
    img {
      position: absolute; top: 50%; left: 50%;
      width: 100%;
      border-radius: 8px;
      transform: translate(-50%, -50%);
    }

  }
</style>
